import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ArrowDownRed",
  "use": "ArrowDownRed-usage",
  "viewBox": "0 0 182.13 181.53",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 182.13 181.53\" id=\"ArrowDownRed\"><path fill=\"#f35379\" d=\"M24.56 154.94l128.36.01V26.58h-23.09v88.95L32.72 18.42 16.39 34.75l97.11 97.11H24.56v23.08z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol